// =====================================================================
// Ada Shoes — Tier Progress Updater (cart drawer + pagina cos)
//
// Reimprospateaza bara de progres tier (`[data-ada-tier-slot]`) dupa ORICE
// modificare a cosului, fara reload.
//
// E theme-agnostic: nu depinde de numele intern al event-urilor din Impulse.
// Prinde direct apelurile AJAX catre /cart/add|change|update|clear — atat prin
// `fetch`, cat si prin `XMLHttpRequest` (Impulse/Archetype pot folosi jQuery.ajax).
// In plus asculta cateva event-uri uzuale, ca bonus.
//
// PLASARE — una din variante:
//   (a) lipeste continutul la finalul assets/global.js (sau theme.js), SAU
//   (b) salveaza ca assets/ada-cart-tier-progress.js si adauga in layout/theme.liquid,
//       inainte de </body>:
//         {{ 'ada-cart-tier-progress.js' | asset_url | script_tag }}
//
// CONFIG: daca section-ul care contine bara are alt nume in Impulse, adauga-l in
// CART_SECTION_IDS (vezi README).
// =====================================================================
(function () {
  'use strict';

  if (window.__adaTierProgressInit) return;
  window.__adaTierProgressInit = true;

  // Section (din sections/) care randeaza snippet-ul cart-tier-progress.
  // La Impulse cart-drawer e SNIPPET (nu section), iar /cart.js nu are tag-uri,
  // deci folosim o mini-section dedicata: sections/ada-cart-tier.liquid.
  // Se incearca pe rand pana cand una returneaza slot-ul.
  var CART_SECTION_IDS = ['ada-cart-tier', 'main-cart-items'];
  var SLOT_SELECTOR = '[data-ada-tier-slot]';
  var CART_MUTATION_RE = /\/cart\/(add|change|update|clear)/i;

  var timer = null;
  function scheduleRefresh() {
    clearTimeout(timer);
    timer = setTimeout(refresh, 150);
  }

  function refresh() {
    if (!document.querySelector(SLOT_SELECTOR)) return;
    tryFetch(0);
  }

  function tryFetch(idx) {
    if (idx >= CART_SECTION_IDS.length) return;
    fetch('/cart?section_id=' + encodeURIComponent(CART_SECTION_IDS[idx]), {
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (res) { return res.ok ? res.text() : Promise.reject(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var freshSlot = doc.querySelector(SLOT_SELECTOR);
        // Sectiune gresita (nu contine slot-ul) -> incearca urmatoarea.
        if (!freshSlot) { tryFetch(idx + 1); return; }
        // Slot gasit: copiaza continutul in TOATE slot-urile din pagina
        // (drawer + pagina cos). Daca acum nu mai e incaltaminte, slot-ul vine
        // gol -> bara dispare automat.
        document.querySelectorAll(SLOT_SELECTOR).forEach(function (slot) {
          slot.innerHTML = freshSlot.innerHTML;
        });
      })
      .catch(function () { tryFetch(idx + 1); });
  }

  // 1) Intercepteaza fetch (Shopify modern, majoritatea temelor)
  if (window.fetch) {
    var _fetch = window.fetch;
    window.fetch = function () {
      var url = arguments[0];
      if (url && typeof url === 'object') url = url.url;
      var promise = _fetch.apply(this, arguments);
      if (typeof url === 'string' && CART_MUTATION_RE.test(url)) {
        promise.then(function () { scheduleRefresh(); }).catch(function () {});
      }
      return promise;
    };
  }

  // 2) Intercepteaza XMLHttpRequest (jQuery.ajax / cod mai vechi din Impulse)
  var _open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__adaUrl = url;
    return _open.apply(this, arguments);
  };
  var _send = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    if (typeof this.__adaUrl === 'string' && CART_MUTATION_RE.test(this.__adaUrl)) {
      this.addEventListener('load', scheduleRefresh);
    }
    return _send.apply(this, arguments);
  };

  // 3) Event-uri uzuale de cos (bonus — daca tema le emite, reactionam mai repede)
  [
    'cart:updated', 'cart:build', 'cart:refresh', 'cart:change',
    'ajaxCart:updated', 'cartDrawer:open', 'cart:open', 'theme:cart:change'
  ].forEach(function (ev) {
    document.addEventListener(ev, scheduleRefresh);
  });

  // 4) Sincronizare initiala cu starea curenta a cosului
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleRefresh);
  } else {
    scheduleRefresh();
  }
})();
